<template>
	<div>
		{{ username }}

		<div ref="local"></div>
		<div ref="remote"></div>

		<div>
			<p v-for="(log, idx) in logs" :key="idx">{{ log }}</p>
		</div>
	</div>
</template>

<script>

//https://media.twiliocdn.com/sdk/js/video/releases/2.13.1/docs/
import axios from "axios";
import Twilio from "twilio-video";
import { mapGetters } from "vuex";

export default {
	name: "Twilio",
	props: {
		username: { type: String, required: true },
	},
	data() {
		return {
			logs: [],
			activeRoom: "",
			localTrack: false,
		};
	},
	created() {
		this.createChatRoom();
	},
	computed: {
		...mapGetters("conference", [
			"getUserName",
			"getMediaStreamConstraints",
		]),
	},
	methods: {
		appendLog(log) {
			this.logs = [...this.logs, log];
		},

		leaveRoomIfJoined() {
			if (this.activeRoom) this.activeRoom.disconnect();
		},

		participantDisconnected(participant) {
			this.$log(`Participant disconnected: ${participant.identity}`);

			document.getElementById(participant.sid).remove();
		},

		participantConnected(participant) {
			this.$log(`Participant condected: ${participant.identity}`);

			const div = document.createElement("div");
			div.id = participant.sid;
			div.innerText = participant.identity;

			participant.on("trackSubscribed", (track) =>
				this.trackSuscribed(div, track)
			);
			participant.on("trackUnsubscribed", this.trackUnsubscribed);

			participant.tracks.forEach((publication) => {
				if (publication.isSuscribed) {
					this.trackSuscribed(div, publication.track);
				}
			});

			this.$refs.remote.appendChild(div);
		},

		trackSuscribed(container, track) {
			container.appendChild(track.attach());
		},

		trackUnsubscribed(track) {
			track.detach().forEach((element) => element.remove());
		},
 
		async getAccessToken() {
			return await axios.get(
				`${process.env.VUE_APP_BACKEND_API_URL}token/awesome-room/${this.username}`
			);
		},

		async createChatRoom() {
			let tokenResponse = await this.getAccessToken();
			let token = tokenResponse.data.token;

			this.leaveRoomIfJoined();

			Twilio.logLevel = "debug";

			let localTracks = await Twilio.createLocalTracks(
				this.getMediaStreamConstraints
			);

			//this.attachTracks(localTracks, this.$refs.local);

			this.$log("try connect");

			let room = await Twilio.connect(token, {
				name: "my-awesome-room",
				tracks: localTracks,
			});

			this.$log("connected");

			room.participants.forEach(this.participantConnected);
			room.on("participantConnected", this.participantConnected);

			room.on("participantDisconnected", this.participantDisconnected);
			room.once("disconnected", (error) => {
				this.$log(error.message);
				room.participants.forEach(this.participantDisconnected);
			});
		},
	},
};
</script>